import customDataTableActionStyle from 'assets/styles/customDataTableActionStyle';
import ViewPaymentHistoryDetail from 'features/Account/components/ViewPaymentHistoryDetail';
import EmptyView from 'features/Others/components/EmptyView';
import { AppDialogHelper } from 'general/components/AppDialog';
import KTBSDropdown, {
  KTBSDropdownAlignments,
} from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import VIDataTable from 'general/components/VietInvoice/VIDataTable';
import VIModal from 'general/components/VietInvoice/VIModal';
import AppData from 'general/constants/AppData';
import AppResource from 'general/constants/AppResource';
import PaymentHelper from 'general/helpers/PaymentHelper';
import SystemHelper from 'general/helpers/SystemHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

AccountPaymentHistoryScreen.propTypes = {
  navItemList: PropTypes.array,
};

AccountPaymentHistoryScreen.defaultProps = {
  navItemList: [],
};

/**
 *
 * @param {{
 *  navItemList: object[],
 * }} props
 * @returns
 */
function AccountPaymentHistoryScreen(props) {
  // MARK --- Params ---
  const { navItemList } = props;
  const { t } = useTranslation();
  const refCardHeader = useRef(null);
  const [cardBodyMaxHeight, setCardBodyMaxHeight] = useState('55vh');
  const { paymentHistoryList, isGettingPaymentHistory, totalPaymentHistory } = useSelector(
    (state) => state?.system
  );
  const [filters, setFilters] = useState(Global.gFilterPaymentHistory);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const columns = useMemo(
    () => [
      {
        name: t('OrderCode'),
        minWidth: '200px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
              style={{
                color: PaymentHelper.getPaymentStatusColor(row?.statusOrder),
              }}
            >
              {row.orderCode}
            </p>
          );
        },
      },
      {
        name: t('PurchaseDate'),
        minWidth: '160px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
              style={{
                color: PaymentHelper.getPaymentStatusColor(row?.statusOrder),
              }}
            >
              {Utils.formatDateTime(row?.createdAt, 'DD/MM/YYYY HH:mm')}
            </p>
          );
        },
      },
      {
        name: `${t('TotalPayment')} (VND)`,
        minWidth: '250px',
        right: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-bolder m-0 text-maxline-3"
              style={{
                color: PaymentHelper.getPaymentStatusColor(row?.statusOrder),
              }}
            >
              {row.totalPayment ? Utils.formatCurrency(row.totalPayment) : ''}
            </p>
          );
        },
      },
      {
        name: t('PaymentType'),
        minWidth: '160px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
              style={{
                color: PaymentHelper.getPaymentStatusColor(row?.statusOrder),
              }}
            >
              {row?.typePayment}
            </p>
          );
        },
      },
      {
        name: t('BuyerName'),
        minWidth: '200px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
              style={{
                color: PaymentHelper.getPaymentStatusColor(row?.statusOrder),
              }}
            >
              {row?.orderName}
            </p>
          );
        },
      },
      {
        name: t('BuyerEmail'),
        minWidth: '200px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
              style={{
                color: PaymentHelper.getPaymentStatusColor(row?.statusOrder),
              }}
            >
              {row?.orderEmail}
            </p>
          );
        },
      },
      {
        name: t('State'),
        sortable: false,
        width: '160px',
        style: {
          borderRight: 0,
        },
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="font-weight-normal m-0 text-maxline-3"
              style={{
                color: PaymentHelper.getPaymentStatusColor(row?.statusOrder),
              }}
            >
              {t(
                _.find(AppData.paymentStatusItems, (item) => item.value === row?.statusOrder).name
              )}
            </p>
          );
        },
      },
      {
        name: '',
        center: true,
        width: '50px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedf3',
        },
        cell: (row, index) => (
          <div className="d-flex align-items-center justify-content-between gap-3 px-3">
            <KTTooltip text={t('ViewDetail')}>
              <i
                className="fa-regular fa-eye text-primary"
                onClick={() => {
                  setSelectedOrder(row);
                  setModalPaymentHistoryDetailShowing(true);
                }}
              />
            </KTTooltip>
          </div>
        ),
      },
    ],
    [t]
  );
  const [modalPaymentHistoryDetailShowing, setModalPaymentHistoryDetailShowing] = useState(false);
  const dropdownMenuItems = useMemo(() => {
    return navItemList.map((item) => {
      return {
        name: item.text,
        value: item.text,
        icon: item.icon,
        onPress: item.onPress,
      };
    });
  }, [navItemList]);

  useEffect(() => {
    SystemHelper.callApiGetPaymentHistory(filters);
  }, [filters]);

  // ---- methods ----
  function handleCancelOrder() {
    setModalPaymentHistoryDetailShowing(false);
    AppDialogHelper.show(t('CancelOrder'), t('TextConfirmCancelOrder'), [
      {
        title: t('No'),
        onClick: () => {
          AppDialogHelper.hide();
          setModalPaymentHistoryDetailShowing(true);
        },
        type: 'neutral',
      },
      {
        title: t('Yes'),
        onClick: async () => {
          // thuc hien huy don hang
          const orderId = selectedOrder?.orderId;
          const res = await PaymentHelper.callApiCancelOrder(orderId);
          if (res) {
            ToastHelper.showSuccess(t('CancelOrderSuccess'));
            AppDialogHelper.hide();
            setSelectedOrder(null);
          }
        },
        type: 'negative',
      },
    ]);
  }

  async function handleResendEmailOrder() {
    setModalPaymentHistoryDetailShowing(false);
    const res = await PaymentHelper.callApiResendEmailPayment(selectedOrder?.orderId);
    if (res) {
      AppDialogHelper.show(
        t('Notification'),
        `Email xác nhận mua hàng đã được gửi về địa chỉ ${selectedOrder?.orderEmail}. Vui lòng kiểm tra email để xem chi tiết thông tin.`,
        [
          {
            title: t('Close'),
            onClick: () => {
              AppDialogHelper.hide();
            },
            type: 'neutral',
          },
        ]
      );
    }
  }

  return (
    <div className="h-100">
      <VIDataTable
        // minusHeight={-65}
        title={
          <div className="d-flex align-items-center justify-content-center gap-1">
            <div className="d-block d-lg-none">
              <KTBSDropdown
                toggleElement={
                  <div className="w-30px h-30px button-close cursor-pointer d-flex align-items-center justify-content-center bg-transparent">
                    <i className="fa-solid fa-bars text-grey" />
                  </div>
                }
                alignment={KTBSDropdownAlignments.start}
                dropdownMenuItems={dropdownMenuItems}
                selectedValue={t('PaymentHistory')}
                onChange={(newValue) => {}}
              />
            </div>{' '}
            {t('PaymentHistory')}
          </div>
        }
        emptyComponent={
          <EmptyView image={AppResource.images.imgEmptyPayment} message={t('NoTransactionsYet')} />
        }
        draggable={false}
        tableStyles={customDataTableActionStyle}
        pagination={{
          perPage: filters.limit,
          total: totalPaymentHistory,
          currentPage: filters.page + 1,
          count: paymentHistoryList?.length + filters.limit * filters.page,
        }}
        onChangePage={(page) => {
          let iNewPage = parseInt(page);
          iNewPage -= 1;
          if (iNewPage < 0) {
            iNewPage = 0;
          }
          Global.gFilterPaymentHistory = {
            ...Global.gFilterPaymentHistory,
            page: iNewPage,
          };
          setFilters(Global.gFilterPaymentHistory);
        }}
        onChangeRowsPerPage={(perPage) => {
          Global.gFilterPaymentHistory = {
            ...Global.gFilterPaymentHistory,
            limit: perPage,
            page: 0,
          };
          setFilters(Global.gFilterPaymentHistory);
        }}
        fullColumns={columns}
        data={paymentHistoryList}
        loading={false}
        onRowClick={(row) => {}}
        onRowDoubleClick={(row) => {
          setSelectedOrder(row);
          setModalPaymentHistoryDetailShowing(true);
        }}
      />

      {/* modal payment history detail */}
      <VIModal
        titleModal={t('OrderDetail')}
        show={modalPaymentHistoryDetailShowing}
        closeBtn
        handleSubmit={() => {}}
        onHide={() => {
          setModalPaymentHistoryDetailShowing(false);
        }}
        modalSize="lg"
        contentModal={
          <ViewPaymentHistoryDetail
            item={selectedOrder}
            onPressCancelOrder={() => {
              handleCancelOrder();
            }}
            onPressResendEmail={() => {
              handleResendEmailOrder();
            }}
          />
        }
      />
    </div>
  );
}

export default AccountPaymentHistoryScreen;
